/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors, fonts, mixins } from '@blend/consumer-components';
import { CustomImage } from '@components/CustomImage/CustomImage';

export namespace IconHeader {
  export interface Props {
    title: string;
    imageName: string;
  }
}

const styles = StyleSheet.create({
  titleContainer: {
    ...mixins.transition('all', 0.3),
    display: 'flex',
    alignItems: 'center',
  },
  alignContentTop: {
    alignItems: 'start',
  },
  titleWrapper: {
    marginLeft: 10,
  },
  title: {
    ...mixins.marginVertical(0),
    lineHeight: 1.2,
    fontSize: 15,
    fontWeight: fonts.weight.medium,
    color: colors.clayPlus4,
  },
  subtitle: {
    fontSize: 12,
    color: colors.newGrayDarker,
    marginTop: 3,
  },
  tagWrapper: {
    position: 'relative',
    top: -2,
  },
  illustrationIcon: {
    ...mixins.border(1, 'solid', colors.clayMinus2),
    borderRadius: 5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 50,
    height: 50,
    backgroundColor: colors.snow,
  },
});

export const IconHeader: React.FC<IconHeader.Props> = ({ title, imageName }) => {
  return (
    <div className={css(styles.titleContainer)} data-it="IconHeader">
      <div className={css(styles.illustrationIcon)}>
        <CustomImage size={'small'} imageName={imageName} />
      </div>
      <div className={css(styles.titleWrapper)}>
        <h2 data-it="title" className={css(styles.title)}>
          {title}
        </h2>
      </div>
    </div>
  );
};
